import {
  LOGIN_ANOTHER_WAY_REQUEST,
  LOGIN_ANOTHER_WAY_SUCCESS,
  LOGIN_ANOTHER_WAY_FAILURE,
  RESET_LOGIN_ANOTHER_WAY_STATE,
} from "../../actionTypes/loginAnotherWay";

interface LoginAnotherWayState {
  loading: boolean;
  data: string;
  error: string;
  success: boolean;
}

const initialState: LoginAnotherWayState = {
  loading: false,
  data: "",
  error: "",
  success: false,
};

export interface LoginAnotherWayAction {
  type: string;
  payload: string;
}

const loginAnotherWay = (
  state = initialState,
  action: LoginAnotherWayAction,
): LoginAnotherWayState => {
  switch (action.type) {
    case LOGIN_ANOTHER_WAY_REQUEST:
      return { ...state, loading: true };
    case LOGIN_ANOTHER_WAY_SUCCESS:
      return { ...state, loading: false, data: action.payload, success: true };
    case LOGIN_ANOTHER_WAY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case RESET_LOGIN_ANOTHER_WAY_STATE:
      return initialState;
    default:
      return state;
  }
};

export default loginAnotherWay;
